export default __webpack_public_path__ + "static/media/neighborhood.9f0e3739.webp";